var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.96666 4.97998C6.83999 4.97998 6.7133 4.93333 6.6133 4.83333L4.48663 2.70667L2.35997 4.83333C2.16663 5.02667 1.84663 5.02667 1.6533 4.83333C1.45997 4.64 1.45997 4.32 1.6533 4.12667L4.13332 1.64665C4.22666 1.55331 4.3533 1.5 4.48663 1.5C4.61997 1.5 4.74665 1.55331 4.83999 1.64665L7.31997 4.12667C7.5133 4.32 7.5133 4.64 7.31997 4.83333C7.21997 4.93333 7.09332 4.97998 6.96666 4.97998Z",
    fill: "#9599A6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.48682 14.5C4.21348 14.5 3.98682 14.2733 3.98682 14V2C3.98682 1.72667 4.21348 1.5 4.48682 1.5C4.76015 1.5 4.98682 1.72667 4.98682 2V14C4.98682 14.2733 4.76015 14.5 4.48682 14.5Z",
    fill: "#9599A6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5198 14.4998C11.3865 14.4998 11.2598 14.4465 11.1665 14.3532L8.6865 11.8731C8.49317 11.6798 8.49317 11.3598 8.6865 11.1665C8.87984 10.9732 9.19984 10.9732 9.39317 11.1665L11.5198 13.2932L13.6465 11.1665C13.8398 10.9732 14.1598 10.9732 14.3532 11.1665C14.5465 11.3598 14.5465 11.6798 14.3532 11.8731L11.8731 14.3532C11.7798 14.4465 11.6465 14.4998 11.5198 14.4998Z",
    fill: "#9599A6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5132 14.5C11.2399 14.5 11.0132 14.2733 11.0132 14V2C11.0132 1.72667 11.2399 1.5 11.5132 1.5C11.7865 1.5 12.0132 1.72667 12.0132 2V14C12.0132 14.2733 11.7932 14.5 11.5132 14.5Z",
    fill: "#9599A6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.5edf346a32f221380acfb3b17c8210bb.svg";
export { ForwardRef as ReactComponent };